import { _js } from '@ifixit/utils/localize';
import { Fragment, useContext, useEffect } from 'react';
import { ViewGuidesButton, OrderPartButton } from '../MiscParts/part_buttons';
import CopyIcon from '../Generic/clipboard';
import { HotSpot } from 'Guide/Schematics/Diagram/Providers/dataContext';
import { TooltipContext } from '../Providers/tooltipContext';
import { KeypressContext } from '../Providers/keypressContext';
import { fromWiki } from '../Generic/fromWiki';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

const ItemContent = ({ data }: { data: iFixitHotSpotItem }) => {
   const name = fromWiki(data, 'name') || data.description;
   const sku = fromWiki(data, 'sku') || '';
   const brand = fromWiki(data, 'brand') || '';

   const itemWikiUrl = fromWiki(data, 'url') || '';
   const itemImageUrl = fromWiki(data, 'imageUrl');

   const copyText = `${brand} ${data.description} ${sku}`;

   return (
      <Fragment>
         {itemImageUrl && (
            <div
               className="hidden sm:block pt-[75%] bg-cover rounded-sm mb-2"
               style={{ backgroundImage: `url(${itemImageUrl})` }}
            />
         )}
         <div className="flex items-center">
            <a
               href={itemWikiUrl}
               target="_blank"
               rel="noopener noreferrer"
               className="font-bold text-base text-center text-gray-800 pr-2 hover:no-underline visited:text-gray-800"
            >
               {name}
            </a>
            <CopyIcon copyText={copyText} />
         </div>
         <div className="flex flex-col gap-2 items-start">
            {sku && (
               <div className="text-sm text-left text-gray-600">
                  {_js('Part Number:') + ' ' + sku}
               </div>
            )}
            {brand && (
               <div className="text-sm text-left text-gray-600">{_js('Brand:') + ' ' + brand}</div>
            )}
            <div className="flex gap-2.5">
               <OrderPartButton data={data} />
               <ViewGuidesButton data={data} />
            </div>
         </div>
      </Fragment>
   );
};

const HotspotTooltipContent = ({ data: group }: { data: HotSpot<iFixitHotSpotItem> }) => {
   const lastIndex = group.items.length - 1;
   const renderedItems = group.items.map((item, index) => {
      const hasSep = index != lastIndex;
      const seperator = hasSep ? (
         <div className="mx-4 my-3 border-t border-gray-300 w-full h-px" />
      ) : null;

      // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook cannot be called inside a callback.
      const tooltipContext = useContext(TooltipContext);
      // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook cannot be called inside a callback.
      const keypressContext = useContext(KeypressContext);
      // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME: React Hook cannot be called inside a callback.
      useEffect(() => {
         const closeTooltips = () => {
            tooltipContext.setOpenDataPointId(null);
         };

         const mapping = {
            id: 'Tooltip',
            key: 'Escape',
            action: closeTooltips,
         };

         keypressContext.pushMapping(mapping);

         return () => {
            keypressContext.popMapping(mapping);
         };
      }, [
         keypressContext.pushMapping,
         keypressContext.popMapping,
         tooltipContext.setOpenDataPointId,
      ]);

      return (
         <Fragment key={item.id}>
            <ItemContent data={item} />
            {seperator}
         </Fragment>
      );
   });

   return <Fragment>{renderedItems}</Fragment>;
};

export default HotspotTooltipContent;
